import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  LayoutDashboard, Users, Ticket, ClipboardCheck, Waves, Shield, IndianRupee, BarChart3, ShoppingBag, Wallet, HandCoins,
} from 'lucide-react';

const navItems = [
  { key: 'overview', label: 'Overview', to: '/admin-dashboard', icon: LayoutDashboard, end: true },
  { key: 'analytics', label: 'Analytics', to: '/admin-dashboard/analytics', icon: BarChart3 },
  { key: 'members', label: 'Members', to: '/admin-dashboard/members', icon: Users },
  { key: 'memberships', label: 'Memberships', to: '/admin-dashboard/memberships', icon: Ticket },
  { key: 'attendance', label: 'Attendance', to: '/admin-dashboard/attendance', icon: ClipboardCheck },
  { key: 'batches', label: 'Schedule', to: '/admin-dashboard/batches', icon: Waves },
  { key: 'accessories', label: 'Accessories', to: '/admin-dashboard/accessories', icon: ShoppingBag },
  { key: 'payments', label: 'Payments', to: '/admin-dashboard/payments', icon: IndianRupee },
  { key: 'incentives', label: 'Staff Incentives', to: '/admin-dashboard/incentives', icon: Wallet },
  { key: 'coach-payout', label: 'Coach Payout', to: '/admin-dashboard/coach-payout', icon: HandCoins },
  { key: 'users', label: 'Staff & Users', to: '/admin-dashboard/users', icon: Shield },
];

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
    isActive
      ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-md'
      : 'text-gray-600 hover:bg-blue-50 hover:text-blue-700'
  }`;

const AdminLayout = ({ user }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50" data-testid="admin-panel">
      <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row">
        {/* Sidebar (desktop) */}
        <aside className="hidden md:flex flex-col w-60 shrink-0 border-r border-gray-200 bg-white min-h-screen p-4 sticky top-16 self-start" style={{ height: 'calc(100vh - 4rem)' }}>
          <div className="mb-6 px-2">
            <h2 className="text-lg font-bold text-gray-900">Management</h2>
            <p className="text-xs text-gray-500 mt-0.5 truncate">{user?.name} · {user?.role}</p>
          </div>
          <nav className="space-y-1.5">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink key={item.key} to={item.to} end={item.end} className={linkClass} data-testid={`admin-nav-${item.key}`}>
                  <Icon className="h-4 w-4" />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </aside>

        {/* Mobile horizontal nav */}
        <nav className="md:hidden flex gap-2 overflow-x-auto p-3 bg-white border-b border-gray-200">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink key={item.key} to={item.to} end={item.end} className={linkClass} data-testid={`admin-nav-m-${item.key}`}>
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {/* Content */}
        <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
